import React from 'react';
import { IMessage } from '../../services/messaging/IMessagingProvider';
import { MessageMedia } from './MessageMedia';

interface MessageBubbleProps {
  message: IMessage;
  isOwn: boolean;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({ message, isOwn }) => {
  const formatTimestamp = (timestamp: number | string | Date) => {
    // MySQL DATETIME strings ("2024-01-15 10:30:00") have no timezone suffix.
    // Appending 'Z' ensures they're parsed as UTC so toLocale* converts to
    // the device's local timezone correctly.
    let date: Date;
    if (typeof timestamp === 'string' && !timestamp.includes('Z') && !timestamp.includes('+')) {
      date = new Date(timestamp.replace(' ', 'T') + 'Z');
    } else {
      date = new Date(timestamp);
    }
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();

    if (isToday) {
      return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    } else {
      return date.toLocaleDateString([], { month: 'short', day: 'numeric' }) +
        ' ' + date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: isOwn ? 'flex-end' : 'flex-start',
        marginBottom: '8px'
      }}
    >
      <div
        style={{
          maxWidth: '70%',
          padding: '10px 14px',
          borderRadius: '18px',
          backgroundColor: isOwn ? 'var(--chat-bubble-color, var(--primary-color))' : 'var(--chat-bubble-received-color, var(--background-paper))',
          color: isOwn ? 'var(--chat-bubble-text, #ffffff)' : 'var(--chat-bubble-received-text, var(--text-primary))',
          border: isOwn ? 'none' : '1px solid var(--border-color)',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
          wordWrap: 'break-word',
          overflowWrap: 'break-word'
        }}
      >
        {message.content && (
          <div style={{ marginBottom: message.mediaUrl ? '8px' : '0' }}>
            {message.content}
          </div>
        )}

        {message.mediaUrl && (
          <MessageMedia
            mediaType={message.mediaType as 'image' | 'video' | 'link' | 'audio'}
            mediaUrl={message.mediaUrl}
            thumbnailUrl={message.thumbnailUrl}
            mediaKey={message.mediaKey}
            mediaMimeType={message.mediaMimeType}
            allowDownload={false}
          />
        )}

        <div
          style={{
            fontSize: '11px',
            marginTop: '4px',
            opacity: 0.7,
            textAlign: 'right',
            color: 'var(--info-color, #2196f3)'
          }}
        >
          {formatTimestamp(message.timestamp)}
          {isOwn && (
            <span style={{ marginLeft: '4px', verticalAlign: 'middle' }} title={message.status === 'read' ? 'Seen' : 'Sent'}>
              <span
                className="material-icons"
                style={{
                  fontSize: '14px',
                  verticalAlign: 'middle',
                  color: 'var(--info-color, #2196f3)'
                }}
              >
                {message.status === 'read' ? 'done_all' : 'done'}
              </span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
